var exports = {
  "kL": "xa15a2ab7--4656f2--container",
  "AS": "xa15a2ab7--4656f2--item",
  "C2": "xa15a2ab7--4656f2--updated",
  "Bu": "xa15a2ab7--4656f2--in_hidden_base",
};

module.exports = exports;
